export const SET_RECENTS = "SET_RECENTS";
export const SET_ITEM_DETAILS = "SET_ITEM_DETAILS";
